import {
  DNDQ_SELECT_SEQUENCE,
  DNDQ_SUBMIT_ANSWER,
  GROUPED_DNDQ_SELECT_SEQUENCE,
  GROUPED_DNDQ_SUBMIT_ANSWER,
} from '../../Redux.constants';
import {
  selectNewSliderSequence,
  submitDNDQAnswer,
  selectNewSequenceInGroup,
  submitGroupedDNDQAnswer,
} from './helper';

export function DNDQReducer(state = {}, action) {
  switch (action.type) {
    case DNDQ_SELECT_SEQUENCE:
      return selectNewSliderSequence(state, action.payload);
    case DNDQ_SUBMIT_ANSWER:
      return submitDNDQAnswer(state, action.payload);
    case GROUPED_DNDQ_SELECT_SEQUENCE:
      return selectNewSequenceInGroup(state, action.payload);
    case GROUPED_DNDQ_SUBMIT_ANSWER:
      return submitGroupedDNDQAnswer(state, action.payload);
    default:
      return state;
  }
}
